export const GROUP = 'group';
